module.exports = __webpack_public_path__ + "media/images/icons/icon-admissions-e332b7fa71e099094b05a138bfff6a85.svg";